import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "triggerValue", "dropdown", "yearLabel", "grid", "hiddenInput"]
  static values = {
    name: String,
    value: String,
    minYear: { type: Number, default: 1990 },
    maxYear: { type: Number, default: new Date().getFullYear() + 6 },
    placeholder: { type: String, default: "Select month" }
  }

  static months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ]

  connect() {
    this.currentYear = new Date().getFullYear()
    this.selectedMonth = null
    this.selectedYear = null

    if (this.valueValue) {
      const parts = this.valueValue.split(" ")
      if (parts.length === 2) {
        this.selectedMonth = this.constructor.months.indexOf(parts[0])
        this.selectedYear = parseInt(parts[1])
        this.currentYear = this.selectedYear
      }
    }

    this.renderGrid()
    this.updateTriggerLabel()
    this.closeDropdown()

    this.outsideClickHandler = (e) => {
      if (!this.element.contains(e.target)) this.closeDropdown()
    }
    document.addEventListener("click", this.outsideClickHandler)
  }

  disconnect() {
    document.removeEventListener("click", this.outsideClickHandler)
  }

 toggleDropdown(event) {
  event.stopPropagation()
  const isHidden = this.dropdownTarget.classList.contains("hidden")

  if (isHidden) {
    const triggerRect = this.triggerTarget.getBoundingClientRect()
    const spaceBelow = window.innerHeight - triggerRect.bottom
    const dropdownHeight = 260

    if (spaceBelow < dropdownHeight) {
      this.dropdownTarget.style.bottom = "100%"
      this.dropdownTarget.style.top = "auto"
      this.dropdownTarget.style.marginBottom = "6px"
      this.dropdownTarget.style.marginTop = "0"
    } else {
      this.dropdownTarget.style.top = "100%"
      this.dropdownTarget.style.bottom = "auto"
      this.dropdownTarget.style.marginTop = "6px"
      this.dropdownTarget.style.marginBottom = "0"
    }
  }

  this.dropdownTarget.classList.toggle("hidden")
}

  closeDropdown() {
    this.dropdownTarget.classList.add("hidden")
  }

  prevYear(event) {
    event.stopPropagation()
    this.currentYear--
    this.renderGrid()
  }

  nextYear(event) {
    event.stopPropagation()
    this.currentYear++
    this.renderGrid()
  }

  selectMonth(event) {
    event.stopPropagation()
    const monthIndex = parseInt(event.currentTarget.dataset.monthIndex)
    this.selectedMonth = monthIndex
    this.selectedYear = this.currentYear
    this.hiddenInputTarget.value = `${this.constructor.months[monthIndex]} ${this.currentYear}`
    this.updateTriggerLabel()
    this.renderGrid()
    this.closeDropdown()
  }

  updateTriggerLabel() {
    if (this.selectedMonth !== null && this.selectedYear !== null) {
      this.triggerValueTarget.textContent = `${this.constructor.months[this.selectedMonth]} ${this.selectedYear}`
      this.triggerValueTarget.classList.remove("text-ink-muted")
      this.triggerValueTarget.classList.add("text-ink")
    } else {
      this.triggerValueTarget.textContent = this.placeholderValue
      this.triggerValueTarget.classList.add("text-ink-muted")
      this.triggerValueTarget.classList.remove("text-ink")
    }
  }

  renderGrid() {
    this.yearLabelTarget.textContent = this.currentYear

    const prevBtn = this.element.querySelector('[data-action*="prevYear"]')
    const nextBtn = this.element.querySelector('[data-action*="nextYear"]')
    if (prevBtn) prevBtn.disabled = this.currentYear <= this.minYearValue
    if (nextBtn) nextBtn.disabled = this.currentYear >= this.maxYearValue

    this.gridTarget.innerHTML = ""
    this.constructor.months.forEach((month, index) => {
      const cell = document.createElement("div")
      const isSelected = this.selectedMonth === index && this.selectedYear === this.currentYear
      cell.className = `picker-cell${isSelected ? " sel" : ""}`
      cell.textContent = month.substring(0, 3)
      cell.dataset.monthIndex = index
      cell.dataset.action = "click->month-picker#selectMonth"
      this.gridTarget.appendChild(cell)
    })
  }
}